import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  container: {
    [theme.breakpoints.down('xs')]: {
      width: '80% !important',
    },
    [theme.breakpoints.down('sm')]: {
      width: '30rem',
    },
    width: '37.5rem',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    height: 'fit-content',
    maxHeight: '85%',
    overflowY: 'auto',
    borderRadius: '0.5rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    backgroundColor: '#1E1E1E;',
    padding: '1.5rem',
    wordBreak: 'keep-all!important',
    '&:active': {
      outline: 'none',
    },
    '&:focus': {
      outline: 'none',
    },
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: '0.4em',
    },
    '&::-webkit-scrollbar-track': {
      '-webkit-box-shadow': 'inset 0 0 1px rgba(0,0,0,0.1)',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0,0,0,.1)',
      outline: '1px solid slategrey',
    },
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  subHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '2px',
  },
  pageTitle: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '22px',
    },
    fontSize: '24px',
    color: '#fff',
  },
  tabButton: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px',
    },
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    fontSize: '14px',
    color: '#cfcfcf',
    cursor: 'pointer',
    padding: '6px 10px 6px 6px',
    borderRadius: '4px',
    border: '1px solid #404040',
    backgroundColor: '#292929',
  },
  separater: {
    borderBottomWidth: '1px',
    borderBottomColor: '#686868',
    borderBottomStyle: 'solid',
    margin: '4px 0',
  },
  stepHeader: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px',
    },
    fontSize: '14px',
    color: '#fff',
    fontWeight: '400',
    display: 'flex',
    alignItems: 'center',
    transition: 'opacity 150ms',
  },
  section: {
    marginBottom: '12px',
  },
  noMargin: {
    margin: '0!important',
  },
  compactTooltip: {
    maxWidth: '26rem',
  },
  tooltipImg: {
    [theme.breakpoints.down('xs')]: {
      width: '14px',
    },
    margin: '0 10px 0 5px',
    width: '16px',
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '12px',
  },
  promptMethodContainer: {
    display: 'flex',
    gap: '8px',
    width: 'fit-content',
    alignItems: 'center',
    color: '#404040',
    overflow: 'hidden',
  },
  promptMethod: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px',
    },
    fontSize: '14px',
    padding: '6px 9px',
    cursor: 'pointer',
    transition: 'opacity 150ms',
    borderRadius: '6px',
    border: '1px solid #404040',
  },
  selectedPromptMethod: {
    backgroundColor: '#292929',
    color: '#fff',
  },
  textInput: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '13px !important',
    },
    fontFamily: 'inherit',
    fontSize: '14px',
    padding: '0 12px',
    width: '100%',
    minHeight: '36px',
    color: '#fff',
    backgroundColor: '#292929',
    border: '1px solid #404040',
    borderRadius: '8px !important',
    '&:focus': {
      outline: 'none',
    },
  },
  autocomplete: {
    '& .MuiPaper-root-MuiAutocomplete-paper': {
      fontSize: '10px!important',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& .MuiInputBase-sizeSmall': {
      padding: '4px 36px 4px 12px !important',
      gap: '4px',
      minHeight: '34px',
      fontFamily: 'inherit',
    },
    '& .MuiAutocomplete-tag': {
      margin: '0',
    },
    '& .MuiAutocomplete-clearIndicator': {
      display: 'none',
    },
    '& .MuiInputBase-input': {
      [theme.breakpoints.down('xs')]: {
        fontSize: '12px!important',
      },
      fontSize: '14px',
      padding: '0!important',
      color: '#fff!important',
      '&::placeholder': {
        color: '#757575!important',
        opacity: '1!important',
      },
    },
  },
  autocompletePaper: {
    '& .MuiAutocomplete-noOptions': {
      [theme.breakpoints.down('xs')]: {
        fontSize: '13px',
      },
      fontSize: '14px',
      padding: '6px 16px',
      marginTop: '6px',
      border: '1px solid #404040',
      borderRadius: '8px',
    },
  },
  autocompleteList: {
    marginTop: '6px!important',
    border: '1px solid #404040!important',
    borderRadius: '8px!important',
    padding: '0!important',
    '& .MuiAutocomplete-option': {
      [theme.breakpoints.down('xs')]: {
        fontSize: '13px!important',
      },
      fontSize: '14px',
      minHeight: '36px!important',
    },
  },
  randomTagsOuterContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '6px',
    marginTop: '12px',
    color: '#888888',
  },
  randomizeIcon: {
    color: '#888888',
    cursor: 'pointer',
  },
  randomTagsContainer: {
    display: 'flex',
    gap: '8px 6px',
    overflowX: 'auto',
    flexDirection: 'row',
    paddingBottom: '8px',
    '&::-webkit-scrollbar': {
      height: '3px',
      width: '3px',
      borderRadius: '8px',
      background: 'none',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#404040',
      borderRadius: '8px',
    },
  },
  tag: {
    display: 'flex',
    alignItems: 'center',
    color: '#fff',
    fontSize: '13px',
    fontWeight: '300',
    padding: '4px 6px',
    whiteSpace: 'nowrap',
    backgroundColor: '#292929',
    borderRadius: '6px',
    border: '1px solid #404040',
    cursor: 'pointer',
  },
  disabled: {
    opacity: '0.5',
    cursor: 'default !important',
  },
  languageSelect: {
    '& .MuiSelect-select': {
      [theme.breakpoints.down('xs')]: {
        fontSize: '12px!important',
      },
      padding: '0 8px!important',
      paddingRight: '24px!important',
      minHeight: '24px!important',
      lineHeight: '26px!important',
      fontSize: '14px',
      border: '1px solid #404040!important',
    },
    '&.MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#404040',
      },
      '&:hover fieldset': {
        borderColor: '#404040',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#404040',
      },
    },
    '& .MuiSelect-icon': {
      fontSize: '20px!important',
      right: '4px!important',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: 'none!important',
    },
  },
  textAreaContainer: {
    position: 'relative',
    color: '#fff',
    border: '1px solid #404040',
    borderRadius: '8px',
    backgroundColor: '#292929',
    paddingTop: '10px',
    overflow: 'hidden',
  },
  textArea: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '13px',
    },
    verticalAlign: 'top',
    resize: 'none',
    width: '100%',
    fontSize: '14px',
    fontFamily: 'inherit',
    lineHeight: '20px',
    color: '#fff',
    border: 'none',
    backgroundColor: '#292929',
    padding: '0px 12px 8px 12px',
    '&:focus': {
      outline: 'none',
    },
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#888888',
      borderRadius: '8px',
    },
  },
  textAreaFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    padding: '10px',
    width: '100%',
  },
  textAreaCount: {
    color: '#cfcfcf',
    fontSize: '11px',
  },
  lyricLabelButton: {
    display: 'flex',
    alignItems: 'center',
    padding: '2px',
    color: '#fff',
    backgroundColor: '#292929',
    borderRadius: '4px',
    border: '1px solid #404040',
    width: 'fit-content',
    height: 'fit-content',
  },
  lyricLabelContainer: {
    fontSize: '14px',
    color: '#fff',
    backgroundColor: '#292929',
    marginBottom: '8px',
    borderRadius: '4px',
    border: '1px solid #404040',
  },
  lyricLabel: {
    padding: '10px',
  },
  popover: {
    '& .MuiPopover-paper': {
      backgroundColor: 'transparent',
      overflow: 'hidden',
    },
  },
  outputButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    maxWidth: '100%',
    gap: '8px',
    marginTop: '12px',
  },
  extensionButton: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px',
      padding: '6px 12px',
      borderRadius: '6px',
    },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '14px',
    fontWeight: '300',
    color: '#9a9a9a',
    borderRadius: '8px',
    cursor: 'pointer',
    padding: '8px 16px',
    border: '1px solid #404040',
    backgroundColor: '#292929',
  },
  extensionSelected: {
    fontWeight: '400',
    border: '1px solid #B9FF66',
    color: '#B9FF66',
  },
  submitContainer: {
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-end',
      gap: '18px',
    },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  submitButton: {
    [theme.breakpoints.down('xs')]: {
      padding: '10px 15px',
      fontSize: '14px',
      minWidth: '100px',
    },
    justifyContent: 'center',
    backgroundColor: '#CAFF73',
    marginLeft: '24px',
    padding: '10px 30px',
    fontSize: '16px',
    textAlign: 'center',
    borderRadius: '8px',
    minWidth: '120px',
    cursor: 'pointer',
  },
  progressButton: {
    [theme.breakpoints.down('xs')]: {
      padding: '10px 10px 10px 15px',
      fontSize: '11px',
      minWidth: '95px',
    },
    backgroundColor: '#A4A4A4!important',
    padding: '10px 20px 10px 30px',
    fontSize: '16px',
    textAlign: 'center',
    borderRadius: '8px',
    minWidth: '120px',
    cursor: 'not-allowed',
    display: 'flex',
  },
  disabledButton: {
    backgroundColor: '#A4A4A4!important',
    cursor: 'not-allowed',
  },
  creditUsageText: {
    fontSize: '12px',
    fontWeight: '400',
    color: '#fff',
    paddingBottom: '3px',
  },
  submitInfo: {
    [theme.breakpoints.down('xs')]: {
      textAlign: 'right',
    },
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: '300',
    color: '#cfcfcf',
  },
  loadingContainer: {
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
    display: 'flex',
    alignItems: 'center',
    color: '#fff',
  },
  loadingText: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '11px',
      lineHeight: '14px',
      maxWidth: '100%',
    },
    fontSize: '13px',
    lineHeight: '16px',
    fontWeight: '300',
    marginLeft: '12px',
  },
  loadingCircle: {
    [theme.breakpoints.down('xs')]: {
      width: '11px!important',
      height: '11px!important',
      marginLeft: '5px',
    },
    marginLeft: '5px',
    width: '15px!important',
    height: '15px!important',
  },
  infiniteScroll: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    paddingRight: '6px',
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #404040',
    padding: '12px',
    borderRadius: '0.5rem',
    color: '#fff',
    fontSize: '0.9rem',
    maxWidth: '50rem',
    [theme.breakpoints.down('sm')]: {
      maxWidth: 'none',
      marginRight: '0',
    },
  },
  clickableCard: {
    cursor: 'pointer',
  },
  cardContent: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  cardInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    marginBottom: '16px',
    maxWidth: '90%',
  },
  cardLabel: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '14px',
    },
    fontSize: '16px',
  },
  cardPrompt: {
    fontSize: '12px',
    fontWeight: '300',
    paddingRight: '12px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  cardTimestamp: {
    fontSize: '12px',
    fontWeight: '300',
    color: '#9A9A9A',
  },
  cardStatus: {
    textAlign: 'center',
    marginLeft: '1rem',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    fontSize: '0.8rem',
    color: '#cfcfcf',
    [theme.breakpoints.down('xs')]: {
      maxWidth: '4rem',
      marginLeft: '0rem',
    },
  },
  cardAction: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
  },
  infoIconImg: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentcolor',
    flexShrink: '0',
    transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    fontSize: '1.5rem',
  },
  audioIcon: {
    marginRight: '-2px',
    marginTop: '-1px',
  },
  expandIcon: {
    color: '#cfcfcf',
    transition: 'all 150ms !important',
    marginRight: '-2px',
    marginBottom: '-6px',
  },
  cardExpand: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '12px',
    gap: '12px',
  },
  tagsSection: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '8px 6px',
  },
  tagsTitle: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '13px',
      lineHeight: '18px',
    },
    fontSize: '14px',
    lineHeight: '20px',
    color: '#fff',
  },
  sectionTitle: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '13px',
      lineHeight: '18px',
    },
    float: 'left',
    fontSize: '14px',
    lineHeight: '20px',
    marginRight: '4px',
    color: '#fff',
  },
  sectionText: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '13px',
      lineHeight: '18px',
    },
    fontSize: '14px',
    fontWeight: '300',
    lineHeight: '20px',
    color: '#fff',
  },
  cardTag: {
    display: 'flex',
    alignItems: 'center',
    color: '#fff',
    fontSize: '13px',
    fontWeight: '300',
    padding: '4px 8px',
    whiteSpace: 'nowrap',
    backgroundColor: '#292929',
    borderRadius: '6px',
    border: '1px solid #404040',
  },
  lyricsContainer: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '13px',
      lineHeight: '18px',
    },
    fontSize: '14px',
    fontWeight: '300',
    lineHeight: '20px',
    padding: '12px',
    color: '#fff',
    backgroundColor: '#292929',
    borderRadius: '4px',
    border: '1px solid #404040',
    whiteSpace: 'pre-line',
    maxHeight: '300px',
    overflowY: 'auto',
    width: '100%',
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#888888',
      borderRadius: '8px',
    },
  },
}));

export { useStyles };
